import { memo } from 'react';
import { Briefcase } from 'lucide-react';
import { BaseNode, type NodeData } from './BaseNode';

function JobNodeComponent({ data, selected }: { data: NodeData; selected?: boolean }) {
  return <BaseNode data={data} selected={selected} icon={Briefcase} nodeType="job" />;
}

export const JobNode = memo(JobNodeComponent);
